/*
 * Copyright (c) 2022 OTB Africa. All rights reserved. <https://otbafrica.com>
 *
 * Created Date: Monday, April 25th 2022, 10:04:38 am
 * Author: OTB Africa, developers@otbafrica.com
 *
 * Use of this source code is governed by the license that can be found in
 * the LICENSE file or at https://developers.otbafrica.com/licenses/
 */

import GroupsIcon from "@mui/icons-material/Groups";
import { Team } from "lib/schemas";
import { getNewDefaultTeam } from "lib/factories";
import { OSActionButton, OSActionButtonProps, useToggleState } from "ui-widgets";
import { TeamForm } from "./TeamForm";
import { useGlobalScope } from "core/providers";

type onCreateNewTeamFunction = (team: Team) => void;

interface NewTeamButtonProps extends Pick<OSActionButtonProps, "variant" | "size"> {
  updateTeamsList: onCreateNewTeamFunction;
  buttonText?: string;
  children?: (args: { onClick: () => void }) => React.ReactNode;
}

export const NewTeamButton = ({ updateTeamsList, buttonText, variant, size, children }: NewTeamButtonProps) => {
  const { handleClose, handleOpen, open } = useToggleState();

  const {
    globalState: { selectedOrganization },
    userContext: { loggedInUser },
  } = useGlobalScope();

  const newTeam = getNewDefaultTeam(selectedOrganization.id, [loggedInUser.id]);

  return selectedOrganization?.id ? (
    <>
      {children?.({ onClick: handleOpen }) ?? (
        <OSActionButton
          actionStyle="custom"
          customIcon={<GroupsIcon />}
          onClick={handleOpen}
          variant="contained"
          size={size}
        >
          {buttonText ?? "Create New Team"}
        </OSActionButton>
      )}
      <TeamForm
        popUpTitle="Create New Team"
        onTeamSaveResponse={updateTeamsList}
        team={newTeam}
        open={open}
        onClose={handleClose}
        fieldsToShow={["team_name"]}
        successMessage="New team created"
      />
    </>
  ) : null;
};
